import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { GameWindowService } from "./gameWindow.services";
import { map, Observable } from "rxjs";
import { Utility } from "../shared/utility/utility";
import { Location } from "@angular/common";
import * as _ from 'underscore';

@Injectable({
    providedIn: 'root'
})
export class ValidRouteGuardService implements CanActivate {
    loobyDetails;
    isValidGroupId;
    constructor(
        private gameWindowService: GameWindowService,
        private utils: Utility,
        private router: Router,
        private location: Location,
    ) { }
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        const gameGroupId = next.paramMap.get('gamegroup');
        const langcode = next.paramMap.get('id');
        const gamegrouptype = next.paramMap.get('gamegrouptype');
        const currentUrl = state.url;
        this.gameWindowService.getLobbies().pipe(map(lobbies => {
            const flattenedData = lobbies.flatMap(parent =>
                parent.gameGroupList.map(group => ({
                    parent,
                    multilingualUrlGameGroup: group.multilingualUrlGameGroup[langcode]
                }))
            );
            const groupedTypeData = _.unique(flattenedData.map(data => data.multilingualUrlGameGroup));
            const filteredLobby = lobbies.filter(lobby => lobby.name !== "seo_content_tabs" && lobby.multilingualUrlLobby && lobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(langcode)] !== langcode);
            const lobby = [...filteredLobby.map(lobby => lobby.multilingualUrlLobby[langcode]), 'allgames', "home"];
            return { lobby, groupedTypeData };
        })).subscribe(data => {
            if (gameGroupId && gamegrouptype === null) {
                this.isValidGroupId = data.lobby.includes(gameGroupId) ? true : false;
            }
            if (gameGroupId && gamegrouptype) {
                this.isValidGroupId = data.groupedTypeData.includes(gamegrouptype) && data.groupedTypeData.includes(gamegrouptype) ? true : false;
            }
            if (!this.isValidGroupId) {
                this.router.navigate([langcode + "/" + langcode]).then(() => {
                    this.location.replaceState(currentUrl);
                });
                return;
            }
        });
        return this.isValidGroupId;
    }

}